import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ANYTIME_PRODUCTS_API_URL } from 'Constants';
import { store } from 'Models/Store';
import { anytimeTicketKeys } from '../Hooks/anytimeTicketKeys';

export type AnytimeProductType = 'TICKET' | 'POS';

export interface AnytimeSaleProduct {
	id: string;
	name: string;
	price: number;
	/** Standard (non-override) price. Equals `price` when no customer-type override applies. */
	basePrice: number;
	/** Customer type (e.g. "Resident") whose override price is applied, or null/absent for the base price. */
	priceOverrideName?: string | null;
	type: AnytimeProductType;
	/** Ticket products flagged staff-only (hidden from customers). POS products are always staff-only. */
	isRestricted?: boolean;
	isDisabled: boolean;
}

const fetchAnytimeProducts = async (customerId?: string | null): Promise<AnytimeSaleProduct[]> => {
	const { data } = await axios.get(ANYTIME_PRODUCTS_API_URL, {
		params: customerId ? { customerId } : undefined,
	});
	return data;
};

export const useAnytimeProductList = (customerId?: string | null) => {
	const { isStaff } = store;
	return useQuery<AnytimeSaleProduct[], Error>({
		queryKey: anytimeTicketKeys.productsList(isStaff, customerId),
		queryFn: () => fetchAnytimeProducts(customerId),
	});
};
